/*
 * @LastEditTime: 2022-06-30 19:08:16
 */
import React, { Component } from 'react';
import './index.less';

class Home extends Component {
    componentDidMount() {
        document.title = '新华英才背调'
    }
    render() {
        return (
            <div className="backtone">
                <div className="backtone__item backtone__banner">
                    <div className="backtone__banner-login">
                        <a href="//ats.chinahr.com/atsbuser/page/login?from=https://credit.chinahr.com/c/uc/index" target="_blank" rel="noreferrer">登录系统</a>
                    </div>
                </div>
                <div className="backtone__item backtone__content01"></div>
                <div className="backtone__item backtone__content02"></div>
                <div className="backtone__item backtone__content03"></div>
            </div>
        );
    }
}

export default Home;